import { Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ForgotPassword from "./pages/auth/ForgotPassword";
import DashboardRoute from "./Routes/DashboardRoute";
import Dashboard from "./pages/user/Dashboard";
import Profile from "./pages/user/Profile";
import CreateProject from "./pages/user/CreateProject";
import ViewProject from "./pages/user/ViewProject";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <div className="app bg-gray-500 overflow-y-hidden">
      <Toaster />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/dashboard" element={<DashboardRoute />}>
          <Route path="" element={<Dashboard />} />
          <Route path="profile" element={<Profile />} />
          <Route path="create-project" element={<CreateProject />} />
          <Route path="view-project/:id" element={<ViewProject />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
